import React from "react";
import { Modal } from "react-bootstrap";

const Terms = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      contentClassName="modern-modal-content"
    >
      <Modal.Header closeButton className="border-0 px-4 pt-4">
        <Modal.Title id="contained-modal-title-vcenter" className="fw-bold color-plum">
          Política de Privacidad
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 pb-4">
        <div className="modern-modal-body-scroll pe-2">
          <section className="mb-4 p-4 rounded-4" style={{ backgroundColor: 'rgba(235, 33, 120, 0.05)' }}>
            <h4 className="fw-bold text-pink mb-3">Introducción</h4>
            <p className="mb-0 text-muted">
              ¡Bienvenido a MiABC! Estamos dedicados a proporcionar una
              experiencia de aprendizaje segura y agradable para los niños.
              Proteger la privacidad de su hijo es una prioridad para nosotros.
              Esta Política de Privacidad explica cómo recopilamos, usamos y
              protegemos la información personal de los niños menores de 13 años
              que usan nuestra aplicación. Al usar MiABC, usted acepta los
              términos descritos en esta política.
            </p>
          </section>

          <section className="mb-4">
            <h4 className="fw-bold color-plum mb-3">Información que Recopilamos</h4>

            <div className="ms-3">
              <h5 className="fw-bold text-pink small text-uppercase mb-2">1. Información Personal</h5>
              <p className="text-muted">
                No recopilamos información personal directamente de los niños sin
                el consentimiento de los padres. La información personal puede
                incluir:
              </p>
              <ul className="text-muted">
                <li className="mb-2">
                  <strong className="color-plum">Información de Contacto del Padre/Tutor:</strong> Dirección de correo
                  electrónico o número de teléfono proporcionados durante el
                  registro de la cuenta para habilitar la comunicación y
                  verificación del consentimiento.
                </li>
                <li>
                  <strong className="color-plum">Información del Niño:</strong> Nombre y edad, proporcionados por los
                  padres o tutores durante la configuración de la cuenta para
                  personalizar la experiencia de aprendizaje.
                </li>
              </ul>

              <h5 className="fw-bold text-pink small text-uppercase mt-4 mb-2">2. Información No Personal</h5>
              <p className="text-muted">
                Podemos recopilar información no personal para mejorar la
                funcionalidad y la experiencia del usuario en la aplicación. Esto
                incluye:
              </p>
              <ul className="text-muted">
                <li className="mb-2">
                  <strong className="color-plum">Información del Dispositivo:</strong> Tipo de dispositivo, sistema
                  operativo e identificadores únicos del dispositivo.
                </li>
                <li>
                  <strong className="color-plum">Datos de Uso:</strong> Información sobre cómo se utiliza la aplicación,
                  incluyendo las funciones accesadas, el tiempo pasado en la
                  aplicación y el progreso del aprendizaje.
                </li>
              </ul>
            </div>
          </section>

          <section className="mb-4 p-4 rounded-4" style={{ backgroundColor: 'rgba(0, 150, 255, 0.05)' }}>
            <h4 className="fw-bold color-plum mb-3">Cómo Usamos la Información</h4>
            <p className="text-muted">
              La información personal se utiliza únicamente para gestionar cuentas, personalización y comunicación segura con los padres. La información no personal nos ayuda a mejorar la aplicación mediante análisis de tendencias y soporte técnico.
            </p>
          </section>

          <section className="mb-4">
            <h4 className="fw-bold color-plum mb-3">Seguridad de los Datos</h4>
            <p className="text-muted">
              Estamos comprometidos a proteger la información de su hijo.
              Implementamos medidas de seguridad estándar en la industria para
              proteger la información personal contra el acceso no autorizado,
              la alteración, la divulgación o la destrucción.
            </p>
          </section>

          <section className="mb-4 p-4 rounded-4" style={{ border: '1px dashed var(--pink-bright)' }}>
            <h4 className="fw-bold text-pink mb-3">Consentimiento Parental</h4>
            <p className="text-muted">
              Requerimos el consentimiento parental verificable antes de
              recopilar, usar o divulgar información personal de niños menores
              de 13 años. Los padres tienen el derecho de revisar, corregir o eliminar la
              información personal de su hijo en cualquier momento
              contactándonos en <a href="mailto:miabc.app@gmail.com" className="text-pink fw-bold">miabc.app@gmail.com</a>.
            </p>
          </section>

          <section className="mb-0">
            <h4 className="fw-bold color-plum mb-3">Contáctenos</h4>
            <p className="text-muted mb-0">
              Si tiene alguna pregunta o inquietud sobre esta Política de
              Privacidad, por favor contáctenos en: <span className="text-pink fw-bold">miabc.app@gmail.com</span>
            </p>
          </section>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 px-4 pb-4">
        <button className="btn-2 px-5 py-2" onClick={props.onHide}>
          Cerrar
        </button>
      </Modal.Footer>

      <style>{`
        .modern-modal-content {
          border-radius: 24px;
          border: none;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
          overflow: hidden;
        }
        .modern-modal-body-scroll {
          max-height: 60vh;
          overflow-y: auto;
        }
        .modern-modal-body-scroll::-webkit-scrollbar {
          width: 6px;
        }
        .modern-modal-body-scroll::-webkit-scrollbar-track {
          background: transparent;
        }
        .modern-modal-body-scroll::-webkit-scrollbar-thumb {
          background: #e0e0e0;
          border-radius: 10px;
        }
        .color-plum { color: var(--plum-bg); }
        .text-pink { color: var(--pink-bright); }
      `}</style>
    </Modal>
  );
};

export default Terms;
